import { render, staticRenderFns } from "./AddPRILAdditionalFileModal.vue?vue&type=template&id=92061c54&scoped=true&"
import script from "./AddPRILAdditionalFileModal.vue?vue&type=script&lang=ts&"
export * from "./AddPRILAdditionalFileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92061c54",
  null
  
)

export default component.exports